import { Modal, Button, Divider } from "antd";
import * as React from "react";
import { Layout, Input, Select, Row, Checkbox } from "antd";
import { Formik, FieldProps, Field } from "formik";
import * as moment from "moment";
import styled from "styled-components";
import * as la from "lodash";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { MODULES, ROLES } from "../../constant/comman";

const PermissionsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 20px;
  margin-top: 16px;
  width: 100%;
`;

const PermissionCard = styled.div`
  background: #ffffff;
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  padding: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  transition: all 0.3s ease;
  
  &:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    border-color: #d9d9d9;
  }
`;

const CardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  padding-bottom: 8px;
  border-bottom: 1px solid #f0f0f0;
  gap: 10px;

  strong {
    font-size: 15px;
    color: #262626;
  }

  .ant-checkbox-wrapper {
    white-space: nowrap;
  }
`;

const CardBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const GlobalToggleContainer = styled.div`
  display: flex;
  gap: 12px;
  margin-bottom: 16px;
  flex-wrap: wrap;
  width: 100%;
`;

const QuickButton = styled(Button)`
  font-size: 13px !important;
  border-radius: 4px !important;
`;

export class UpdateRoleForm extends React.Component {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);

    this.state = {
      data: [],
      view: false,
      isLoading: false,
      visible: false,
      errors: {},
    };
  }

  input;

  validateForm(values) {
    const errors = {};
    console.log("Validating form -- ", values);

    console.log("Validating errors -- ", errors);

    return errors;
  }

  handleSubmit = async (values, action) => {
    console.log(this.props._id);

    this.props.onSubmit(values, this.props.data._id);

    this.setState({
      visible: false,
    });
  };

  changeType = (value) => {
    this.setState({
      selectedType: value,
    });
  };

  handleToggleModule = (moduleValue, isChecked, setFieldValue, values) => {
    const roles = ROLES[moduleValue] || [];
    const modulePermissions = { ...(values.permissions && values.permissions[moduleValue]) };
    roles.forEach((roleName) => {
      modulePermissions[roleName.toLowerCase()] = isChecked;
    });
    setFieldValue(`permissions.${moduleValue}`, modulePermissions);
  };

  handleToggleAll = (isChecked, setFieldValue, values) => {
    const updatedPermissions = { ...values.permissions };
    MODULES.filter((m) => m.value !== "dashboard").forEach((moduleName) => {
      const roles = ROLES[moduleName.value] || [];
      updatedPermissions[moduleName.value] = { ...updatedPermissions[moduleName.value] };
      roles.forEach((roleName) => {
        updatedPermissions[moduleName.value][roleName.toLowerCase()] = isChecked;
      });
    });
    setFieldValue("permissions", updatedPermissions);
  };

  isModuleAllChecked = (moduleValue, values) => {
    const roles = ROLES[moduleValue] || [];
    if (!values.permissions || !values.permissions[moduleValue]) return false;
    return roles.every((roleName) => values.permissions[moduleValue][roleName.toLowerCase()]);
  };

  showModal = () => {
    this.setState({
      visible: true,
    });
  };

  handleOk = (e) => {
    this.setState({
      visible: false,
    });
  };

  handleCancel = (e) => {
    this.setState({
      visible: false,
      selectedType: "",
    });
  };

  render() {
    const { primaryColor, data } = this.props;
    return (
      <div>
        <Formik
          initialValues={{
            email: data.email,
            phone: data.phone,
            first_name: data.first_name,
            last_name: data.last_name,
            permissions: data.permissions,
            role: data.role,
          }}
          validate={this.validateForm}
          onSubmit={this.handleSubmit}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            setFieldValue,
            setFieldTouched,
            isSubmitting,
          }) => {
            return (
              <div>
                <div className="formik-field_wrap" style={{ display: "block", width: "100%" }}>
                  {values.role !== "superAdmin" && (
                    <GlobalToggleContainer>
                      <QuickButton
                        size="small"
                        onClick={() => this.handleToggleAll(true, setFieldValue, values)}
                        style={{ background: "#f5f5f5", borderColor: "#d9d9d9", color: "#595959" }}
                      >
                        Grant All Permissions
                      </QuickButton>
                      <QuickButton
                        size="small"
                        onClick={() => this.handleToggleAll(false, setFieldValue, values)}
                        style={{ background: "#f5f5f5", borderColor: "#d9d9d9", color: "#595959" }}
                      >
                        Revoke All Permissions
                      </QuickButton>
                    </GlobalToggleContainer>
                  )}
                  <PermissionsGrid>
                    {MODULES.map((moduleName, moduleIndex) => {
                      const allChecked = values.role === "superAdmin" || this.isModuleAllChecked(moduleName.value, values);
                      return (
                        <PermissionCard key={moduleIndex}>
                          <CardHeader>
                            <strong>{moduleName.label}</strong>
                            {values.role !== "superAdmin" && (
                              <Checkbox
                                checked={allChecked}
                                onChange={(e) => this.handleToggleModule(moduleName.value, e.target.checked, setFieldValue, values)}
                                style={{ fontSize: "12px", color: "#8c8c8c" }}
                              >
                                Select All
                              </Checkbox>
                            )}
                          </CardHeader>
                          <CardBody>
                            {ROLES[moduleName.value] && ROLES[moduleName.value].map(
                              (roleName, roleIndex) => (
                                <div key={roleIndex}>
                                  {values.role === "superAdmin" ? (
                                    <Checkbox
                                      checked
                                      disabled
                                      name={`permissions.${moduleName.value}.${roleName.toLowerCase()}`}
                                    >
                                      {roleName}
                                    </Checkbox>
                                  ) : (
                                    <Checkbox
                                      onChange={handleChange}
                                      checked={
                                        values.permissions[moduleName.value] &&
                                        values.permissions[moduleName.value][
                                          roleName.toLowerCase()
                                        ]
                                          ? values.permissions[
                                              moduleName.value
                                            ][roleName.toLowerCase()]
                                          : false
                                      }
                                      name={`permissions.${moduleName.value}.${roleName.toLowerCase()}`}
                                    >
                                      {roleName}
                                    </Checkbox>
                                  )}
                                </div>
                              )
                            )}
                          </CardBody>
                        </PermissionCard>
                      );
                    })}
                  </PermissionsGrid>

                  {values.role !== "superAdmin" && (
                    <Button
                      type="primary"
                      style={{
                        marginTop: "24px",
                        background: "#5C6AC4",
                        color: "#fff",
                        borderColor: "#5C6AC4",
                      }}
                      onClick={handleSubmit}
                    >
                      Update
                    </Button>
                  )}
                </div>
              </div>
            );
          }}
        </Formik>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  authToken: state.auth.authToken,
});

export default connect(mapStateToProps)(withRouter(UpdateRoleForm));
